var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { "margin-top": "-10px" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { name: "0" } }, [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("trajectory.newOrderReturn")) + " "
                  ),
                ]),
              ]),
              _c("el-tab-pane", { attrs: { name: "1" } }, [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("trajectory.originalOrderReturnD2D")) +
                      " "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  gap: "10px",
                },
              },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "150px" },
                    attrs: { size: "small" },
                    on: { change: _vm.handleScanTypeChange },
                    model: {
                      value: _vm.scanType,
                      callback: function ($$v) {
                        _vm.scanType = $$v
                      },
                      expression: "scanType",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: {
                        label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
                        value: "waybillNumber",
                      },
                    }),
                    _c("el-option", {
                      attrs: {
                        label: _vm.$t("collectionCenter.ScanNumber"),
                        value: "scanOrderNumber",
                      },
                    }),
                    _c("el-option", {
                      attrs: {
                        label: _vm.$t("home.nfeInvoiceKey"),
                        value: "nfeKey",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-input", {
                  staticStyle: { width: "300px" },
                  attrs: {
                    placeholder: _vm.$t(
                      "collectionCenter.scanOrInputParcelNumber"
                    ),
                    clearable: "",
                    size: "small",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      return (function (e) {
                        return _vm.addReturnData(e)
                      })($event)
                    },
                  },
                  model: {
                    value: _vm.returnNoteVal,
                    callback: function ($$v) {
                      _vm.returnNoteVal = $$v
                    },
                    expression: "returnNoteVal",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "font-size": "14px",
                    color: "#606266",
                    "margin-right": "20px",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("collectionCenter.scanned")) + "："
                  ),
                  _c("span", { staticStyle: { color: "#00a551" } }, [
                    _vm._v(_vm._s(_vm.tableData.length)),
                  ]),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.toReturn },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("collectionCenter.InitiateRejection")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": {
                  background: "#f2f2f2",
                  color: "black",
                  "text-align": "center",
                },
                "max-height": 600,
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ind"),
                  align: "center",
                  prop: "ind",
                  width: "60",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.waybillNumber"),
                  align: "center",
                  prop: "waybillNumber",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.scanInfo"),
                  align: "center",
                  prop: "scanNumber",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.scanner"),
                  align: "center",
                  prop: "person",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.scanTime"),
                  align: "center",
                  prop: "scanTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              title: _vm.$t("collectionCenter.deleteSure"),
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.del(scope.$index)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  color: "red",
                                },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("collectionCenter.Delete")) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "returnDialogClass",
          attrs: {
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "show-close": false,
            title: _vm.$t("collectionCenter.tips"),
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("collectionCenter.initiateReturnTotal")) +
                  "：" +
                  _vm._s(_vm.sumbitMsg.reverseTotal)
              ),
            ]),
            _c(
              "div",
              {
                staticStyle: { "margin-top": "20px", "margin-bottom": "20px" },
              },
              [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "50%" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.orderSuccessful")) +
                        "：" +
                        _vm._s(_vm.sumbitMsg.reverseSuccess)
                    ),
                  ]
                ),
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "50%" } },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.orderFailure")) +
                        "：" +
                        _vm._s(
                          _vm.sumbitMsg.reverseFailList
                            ? _vm.sumbitMsg.reverseFailList.length
                            : 0
                        )
                    ),
                  ]
                ),
              ]
            ),
            _vm.sumbitMsg.reverseFailList &&
            _vm.sumbitMsg.reverseFailList.length > 0
              ? _c(
                  "div",
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("collectionCenter.orderFailedOrder")) +
                          "："
                      ),
                    ]),
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.sumbitMsg.reverseFailList,
                          "max-height": 500,
                          "show-header": false,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("collectionCenter.ind"),
                            prop: "ind",
                            width: "60",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("collectionCenter.order"),
                            prop: "waybillNumber",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("collectionCenter.reason"),
                            prop: "failReason",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleClose },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }